<div class="text-center mt-5" style="color: #f15c23">
      <mat-spinner></mat-spinner>
</div>

<h4 style="color: #F15D22" *ngIf="isLoggedIn$ | async">Attempting to automatically authenticate....</h4>
